
// import { useEffect, useState } from 'react';
import './App.css';
import { Blogs } from './pages/Blogs';
import { Contact } from './pages/Contact';
// import { Dotnav } from './pages/Dotnav';
import { Hero } from './pages/Hero';
import { Navbar } from './pages/Navbar';
import { Projects } from './pages/Projects';
import { Skills } from './pages/Skills';

function App() {
  // const [selectedPage, setSelectedPage] = useState("home");

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY === 0) {
  //       setSelectedPage("home")
  //     }
  //     if (window.scrollY !== 0) setSelectedPage(false);
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [])

  return (
    <div>
      <Navbar />
      <Hero />
      <Skills />
      {/* <Dotnav /> */}
      <Projects />
      <Blogs />
      <Contact />
    </div>
  );
}

export default App;
